module.exports = __webpack_public_path__ + "media/MRI4C.954d4adf.mp3";